import { render, staticRenderFns } from "./OrderComplete.vue?vue&type=template&id=0b7cf5b1&scoped=true&lang=html&"
import script from "./OrderComplete.vue?vue&type=script&lang=js&"
export * from "./OrderComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7cf5b1",
  null
  
)

export default component.exports